<main>
    <section class="well center">
        <div class="container">
            <h3>{{"NAV.SERVICES" | translate}}</h3>
            <div class="row">
                <figure class="grid_6 figure2"><img class="square-image-service" src="assets/images/Teria.jpg"
                                                    alt="">
                    <figcaption>
                        <h5 data-equal-group="1">{{"SERVICES.TERAMYYNTI" | translate}}</h5>
                        <p class="txt1">{{"SERVICES.TERAMYYNTIDESC" | translate}}</p><a href="#teramyynti"
                                                                                        class="btn">{{"READMORE" | translate}}</a>
                    </figcaption>
                </figure>
                <figure class="grid_6 figure2"><img class="square-image-service"
                                                    src="assets/images/Kelamurskain huolto.JPG" alt="">
                    <figcaption>
                        <h5 data-equal-group="1">{{"SERVICES.HUOLTO" | translate}}</h5>
                        <p class="txt1">{{"SERVICES.HUOLTOTITLE" | translate}}</p><a id="teramyynti" href="#huolto"
                                                                                    class="btn">{{"READMORE" | translate}}</a>
                    </figcaption>
                </figure>
            </div>
        </div>
    </section>
    <section class="well center bg-color">
        <div class="container services-container">
            <div>
                <h3 class="center" style="text-align: end">{{"SERVICES.TERAMYYNTI" | translate}}</h3>
                <h5 class="off2">{{"SERVICES.VARAOSATTITLE" | translate}}</h5>
                <p class="txt1">{{"SERVICES.VARAOSATDESC" | translate}}</p>
            </div>
            <img class="image-service service-container-image"
                 style="margin-top: 20px; object-fit: contain;height: auto;" src="assets/images/Osia.jpg" alt="">
        </div>
        <div style="width: 100%; display: flex; justify-content: center; align-items: center;padding-top: 60px;margin-bottom: -15px;">
            <a id="huolto" href="#contact-info"
               class="btn">{{"OTAYHTEYTTA" | translate}}</a>
        </div>
    </section>
    <section class="well center">
        <div class="container services-container">
            <img class="image-service" style="margin-bottom: 20px" src="assets/images/Huollettu puomisto.jpg" alt="">
            <div>
                <h3>{{"SERVICES.HUOLTO" | translate}}</h3>
                <h5 class="off2">{{"SERVICES.HUOLTOTITLE" | translate}}</h5>
                <p class="txt1">{{"SERVICES.HOULTODESC" | translate}}</p>
            </div>
        </div>
        <div>
            <h4 id="contact-info" style="margin-top: 50px">{{"CONTACT-INFO" | translate}}</h4>
            <hr/>
            <div>
                <h6 style="color: black">{{"TONI-CONTACT-INFO-TITLE" | translate}}</h6>
                <p>{{"PUHELIN" | translate}}: <a style="color: black" href="tel:+358447666977">+358 44 766 6977</a></p>
                <hr/>
            </div>
        </div>
    </section>
</main>
